<template>
  <h1 class="title has-text-centered is-spaced">
    <go-to-dashboard-button />

    {{ accessesQty }} {{ $t("accesses.accesses") }}
    <span v-show="!c1 && !c2">&nbsp;&nbsp;</span>

    <br v-show="c1" />

    <button
      class="button"
      @click="$emit('get-accesses')"
      :style="c1 ? 'margin-top: 1rem;' : ''"
    >
      <b-icon icon="sync-alt"></b-icon>
    </button>

    <div v-if="permissions.downloadAccessesReport" class="inline">
      &nbsp;
      <button
        class="button"
        @click="$emit('download-accesses-report')"
        :style="c1 ? 'margin-top: 1rem;' : ''"
      >
        <b-icon icon="save"></b-icon>
      </button>
    </div>

    &nbsp;
    <span
      :style="
        c1 || c2
          ? 'position: relative; top: -0.1rem;'
          : 'position: relative; top: -1.1rem;'
      "
    >
      <b-datepicker
        style="width: 210px; display: inline-block;"
        :placeholder="$t('accesses.selectPeriod')"
        v-model="dates"
        range
        @input="$emit('update-dates', dates)"
        :mobile-native="false"
      ></b-datepicker>
    </span>

    &nbsp;
    <span
      :style="
        c1
          ? 'position: relative; top: 0.1rem;'
          : 'position: relative; top: -0.95rem;'
      "
    >
      <b-select
        :placeholder="$t('accesses.all')"
        style="display: inline-block;"
        v-model="accessFilter"
        @input="$emit('update-accesses-filter', accessFilter)"
      >
        <option value="">
          {{ $t("accesses.allAccesses") }}
        </option>

        <option value="rejected-accesses">
          {{ $t("accesses.deniedAccesses") }}
        </option>

        <option value="suspect-accesses">
          {{ $t("accesses.suspectAccesses") }}
        </option>

        <option value="status-new">
          {{ $t("accesses.filterStatusNew") }}
        </option>

        <option value="status-analyse">
          {{ $t("accesses.filterStatusAnalyse") }}
        </option>

        <option value="status-deviation">
          {{ $t("accesses.filterStatusDeviation") }}
        </option>

        <option value="status-ok">
          {{ $t("accesses.filterStatusOk") }}
        </option>

        <option value="status-recovered">
          {{ $t("accesses.filterStatusRecovered") }}
        </option>

        <option value="status-loss">
          {{ $t("accesses.filterStatusLoss") }}
        </option>
      </b-select>
    </span>

    <b-field style="margin-top: 10px">
      <b-select
        :placeholder="$t('accesses.store')"
        class="inline"
        v-model="store"
        @input="$emit('update-store', store)"
      >
        <option value="">{{ $t("accesses.allStores") }}</option>
        <option
          v-for="s in orderedStores"
          :key="s._id"
          :value="`${s._id}|${s.storeInfo.name}`"
        >
          {{ s.storeInfo.name }}
        </option>
      </b-select>
    </b-field>

    <hr />
  </h1>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import { responsive } from "../../mixins/responsive";
import goToDashboardButton from "../common/GoToDashboardButton";

export default {
  props: ["accessesQty", "storeId", "storeName"],

  mixins: [common, responsive],

  components: {
    goToDashboardButton
  },

  data() {
    return {
      dates: [],
      store: undefined,
      accessFilter: ""
    };
  },

  computed: {
    ...mapGetters(["permissions", "stores", "preferences"]),

    c1() {
      return this.windowWidth < 680;
    },

    c2() {
      return this.windowWidth < 366;
    },

    orderedStores() {
      let orderedStores = [];
      if (this.preferences.storesOrder === "alphabetical") {
        orderedStores = [...this.stores].sort((a, b) => {
          return a.storeInfo.name.localeCompare(b.storeInfo.name);
        });
      } else {
        orderedStores = this.stores;
      }
      return orderedStores;
    }
  },

  mounted() {
    this.store = this.storeId ? `${this.storeId}|${this.storeName}` : "";
    this.dates = [new Date(), new Date()];
  }
};
</script>

<style scoped>
hr {
  background-color: hsl(0, 0%, 71%);
}
.inline {
  display: inline;
}
</style>
